export default {
  getCntGridExmpl: state => state.cnt,
  getGridDataGridExmpl: state => state.gridData,
  getSearchParamGridExmpl: state => state.searchParam,
  getProjectListGridExmpl: state => state.projectList,
  getColumnHeaderGridExmpl: state => state.columnHeaderList,
  getColumnNameGridExmpl: state => state.columnNameList,
};



// WEBPACK FOOTER //
// ./src/vuex/sample/gridExmpl/gridExmplGetter.js